import { render, staticRenderFns } from "./AddTag.vue?vue&type=template&id=430f0fd6&"
import script from "./AddTag.vue?vue&type=script&lang=js&"
export * from "./AddTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports